import { useLocation } from 'react-router-dom';

const Navbar = () => {

    const location = useLocation();

    return (
        <header id="header" className="header d-flex align-items-center fixed-top">
            <div className="container position-relative d-flex align-items-center justify-content-between">

                <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">
                    <img src="assets/images/logo/isotipo-blanco.png" alt="" />
                </a>

                <nav id="navmenu" className="navmenu">
                    <ul>
                        <li><a href="/">Sitio web</a></li>
                        <li><a href="/login" className={location.pathname == '/login' ? 'active' : ''}>Iniciar sesión</a></li>
                        <li><a href="/register" className={location.pathname == '/register' ? 'active' : ''}>Crear cuenta</a></li>
                    </ul>
                    <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                </nav>

            </div>
        </header>
    )
}

export default Navbar;